export default __webpack_public_path__ + "static/media/success.e55a11b4.png";